
import {postRequestWithoutSession} from "./helper-without-session"
export const signInUserApi = (data) => postRequestWithoutSession('login',data);





// WEBPACK FOOTER //
// ./src/api/Admin/SignIn.js